module.exports = " <transition name=toast-fade> <div class=toast-wrap v-show=showing>{{text}}</div> </transition> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./web/components/toast/toast.vue
// module id = 11
// module chunks = 0 3 7 8 9 10 12 13 16 17 23 24 25 26 30 31 32 33 34 35 36 37 38 39 40 41 42 44 48 49 52 53 54 55 74 75 77 78 79 82 89 92 93 94 97 103 104 105 106 118 119 120 121 125 129 133 134 135 142 144 145 146 147 148 149 150 151 154 155 156 159 161 162 164 165 166 168 169 170 171 172 173